import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { ChevronDownMini } from '@xsolla/ui-icons';

import { CheckListItems } from '../../../api/dasboard/types';
import { useAnimatedCollapse } from '../../../hooks';
import { ProgressCircle } from '../../ui/icons';
import CheckListItem from './CheckListItem';
import {
  CheckListCardContent,
  CheckListCardHead,
  CheckListCardSubtitle,
  CheckListCardTitle,
  CheckListCardWrapper,
  ChevronMiniWrapper,
  FlexWithGap,
  ProgressIconWrapper,
  TitlesWrapper
} from './style';

type Props = {
  name: string;
  checklistItems: CheckListItems;
  isOpened?: boolean;
  options: {
    [key: string]: string[];
  };
};

const CheckListCard = ({ name, checklistItems, options, isOpened = false }: Props): JSX.Element => {
  const [progress, setProgress] = useState<number>(0);
  const [numberOfSettings, setNumberOfSettings] = useState<number>(0);
  const { collapseHandle, contentHeight, ref } = useAnimatedCollapse({ isOpen: isOpened });
  const intl = useIntl();

  useEffect(() => {
    if (!options[name]) {
      return;
    }
    setNumberOfSettings(options[name].length);
    setProgress(
      options[name].reduce((acc: number, optionName) => {
        if (checklistItems[optionName]) {
          return acc + 1;
        }
        return acc;
      }, 0)
    );
  }, [checklistItems]);

  const GetProgressStatus = useCallback(() => {
    const result = Math.ceil((8 / numberOfSettings) * progress);
    return result || 0;
  }, [progress, numberOfSettings]);

  return (
    <CheckListCardWrapper>
      <CheckListCardHead onClick={collapseHandle}>
        <FlexWithGap>
          <ProgressIconWrapper>
            <ProgressCircle progress={GetProgressStatus()} />
          </ProgressIconWrapper>
          <TitlesWrapper>
            <CheckListCardTitle>{intl.messages[`check-list.${name}.title`]}</CheckListCardTitle>
            <CheckListCardSubtitle>
              {intl.messages[`check-list.${name}.subtitle`]}
            </CheckListCardSubtitle>
          </TitlesWrapper>
        </FlexWithGap>
        <ChevronMiniWrapper isOpen={!!contentHeight}>
          <ChevronDownMini />
        </ChevronMiniWrapper>
      </CheckListCardHead>
      <CheckListCardContent ref={ref} contentHeight={contentHeight}>
        {options[name].map((item) => (
          <CheckListItem key={item} completed={!!checklistItems?.[item]} name={item} />
        ))}
      </CheckListCardContent>
    </CheckListCardWrapper>
  );
};

export default CheckListCard;
